import { inject } from "fw";
import { handle } from "fw-state";
import { LogoutAction, StartAction } from "./actions";
import { AtsFeatureFlagsRepository } from "network/ats-feature-flags-repository";

import { FeatureFlagsImplicitsFilter, ImplicitFeatureFlagOrganizationInfo } from "models/feature-flags";
import { GridStore } from "./components/grid";

const CACHE_KEY = "ff-implicit-store";

export class FFImplicitsNextPageAction {}
export class FFImplicitsPreviousPageAction {}

export class FFImplicitsUpdateRefreshDateAction {
    constructor(public date: Date = new Date()) {}
}

export class FFImplicitsFetchListAction<Filter> {
    constructor(
        public filter: Filter = null,
        public search: string = null,
        public sort: string = null
    ) {}
}

@inject
export class FeatureFlagsImplicitsStore extends GridStore<ImplicitFeatureFlagOrganizationInfo, FeatureFlagsImplicitsFilter> {
    constructor(private network: AtsFeatureFlagsRepository) {
        super(CACHE_KEY);
    }

    @handle(StartAction)
    private startAction(action: StartAction) {
        this.handleStartAction(action);
    }

    @handle(LogoutAction)
    private logoutAction() {
        this.handleLogoutAction();
    }

    @handle(FFImplicitsUpdateRefreshDateAction)
    private updateRefreshedDate(action: FFImplicitsUpdateRefreshDateAction) {
        this.setState((state) => ({
            ...state,
            updatedDate: action.date
        }));
    }

    @handle(FFImplicitsFetchListAction)
    private fetchListAction(action: FFImplicitsFetchListAction<null>) {
        this.handleFetchList(action, () => {
            this.loadFFImplicitsList();
        });
    }

    @handle(FFImplicitsNextPageAction)
    private nextPageAction(action: FFImplicitsNextPageAction) {
        this.handleNextPageAction(action, async (nextPageToken) => {
            await this.loadFFImplicitsPageData(null, nextPageToken);
        });
    }

    @handle(FFImplicitsPreviousPageAction)
    private previousPageAction(action: FFImplicitsPreviousPageAction) {
        this.handlePreviousPage(action, async (previousPageToken) => {
            await this.loadFFImplicitsPageData(previousPageToken, null);
        });
    }

    private async loadFFImplicitsList() {
        const { currentPreviousPageToken, currentNextPageToken } = this.state;
        this.setState((state) => ({
            ...state,
            filter: {
                ...state.filter
            }
        }));
        await this.loadFFImplicitsPageData(currentPreviousPageToken, currentNextPageToken);
    }

    private async loadFFImplicitsPageData(previousPageToken: string, nextPageToken: string) {
        const { pageSize, sort, filter, search } = this.state;

        try {
            const resp = await this.network.getFlagImplicits(filter.Flag, null, search, sort, previousPageToken, nextPageToken, pageSize);

            this.setState((state) => ({
                ...state,
                loaded: true,
                previousPageToken: resp.PreviousPageToken,
                nextPageToken: resp.NextPageToken,
                currentPreviousPageToken: previousPageToken,
                currentNextPageToken: nextPageToken,
                list: resp.Results,
                total: resp.Total
            }));
        } catch (err) {
            this.setState((state) => ({ ...state, loaded: true, errorLoading: true }));
        }
    }
}
